<template>
  <div class="PaymentCard">
    <div class="left">
      <div class="top">
        <p class="name">{{ name }}</p>
        <p>
          <span class="id">ID: {{ refId }}</span>
        </p>
      </div>
      <p class="id">{{ date }}</p>
    </div>
    <div class="right">
      <div :style="download ? 'visibility: inherit;' : 'visibility: hidden;'">
        <SvgDownload @click="downloadPay()" />
      </div>
      <p>
        <span class="budget" v-html="$options.filters.currencyFormatFilter(amount)"></span>
        {{ currency }}
      </p>
      <p class="id">Bank account</p>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import moment from 'moment';
  import SvgDownload from '@/assets/img/download.svg';

  export default {
    name: 'PaymentCard',
    components: {
      SvgDownload,
    },
    props: {
      name: String,
      id: String,
      refId: String,
      amount: Number,
      currency: String,
      created: String,
      download: Boolean,
    },
    computed: {
      date() {
        return moment(this.created).format('DD MMM YYYY HH:mm');
      },
    },
    methods: {
      ...mapActions('Campaigns', ['doGetPayments']),
      async downloadPay() {
        const payment = await this.doGetPayments(this.refId);
        const url = window.URL.createObjectURL(new Blob([payment]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Invoice-${this.refId}-${this.id}.pdf`);
        document.body.appendChild(link);
        link.click();
      },
    },
  };
</script>

<style lang="scss">
@import "../assets/styles/variables";
.PaymentCard {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 16px;
  margin: 16px 0;
  display: flex;
  padding: 16px;
  justify-content: space-between;
  @media (max-width: 996px) {
    padding: 14px 16px;
  }
  .name {
    font-family: "Roboto";
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    color: #1a1a1d;
  }
  .budget {
    font-family: "Roboto";
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    color: #1a1a1d;
  }
  .id {
    font-family: "Roboto";
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #9b9b9d;
  }
  .left,
  .right {
    display: flex;
    flex-direction: column;
  }
  .left {
    display: flex;
    justify-content: space-between;
  }
  .right {
    align-items: flex-end;
    svg {
      margin-top: -8px;
      cursor: pointer;
    }
  }
  p {
    font-size: 14px;
  }
}
</style>
